import React from 'react';

const Input4options = ({ question, handleAnswer, answerStatus }) => {

    return (
        <div className="answerInputs">
            {question.options.map((option, index) => (
                <button key={`answer-${index}`} onClick={() => handleAnswer(option)} className={answerStatus ? (question.correctAnswer === option ? 'btn-green' : 'btn-red') : 'btn-secondary'}>
                        {option} 
                </button>
            ))}
        </div>
    );
};

export default Input4options;
